import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_8: FaireProductEntity = {
  token: "casa-bosques-8",
  type: "product",
  name: "Night Blooms Earth Candle",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
  priceDollars: 28,
  msrpDollars: 42,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
